var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"link":"","to":_vm.to,"target":_vm.target}},[_c('v-list-item-action',[_c('v-icon',[_vm._v(_vm._s(this.icon))])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }